export function appendEphemeralParam(url) {
    if (typeof window === 'undefined' || typeof url !== 'string')
        return url ?? '';
    const isEphemeral = process.env.EPHEMERAL === 'true';
    const prNumber = process.env.CIRCLE_PR_NUMBER;
    if (!isEphemeral || !prNumber)
        return url;
    const paramKey = '__ufrn_app_version__=pr-';
    if (url.includes(paramKey))
        return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${paramKey}${prNumber}`;
}
